import { useEffect, useState } from 'react';

export const isDocumentDarkMode = () => (
  typeof document !== 'undefined'
  && document.documentElement.getAttribute('data-bs-theme') === 'dark'
);

export const useDocumentThemeSync = () => {
  const [isDarkMode, setIsDarkMode] = useState(isDocumentDarkMode);

  useEffect(() => {
    setIsDarkMode(isDocumentDarkMode());

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'data-bs-theme') {
          setIsDarkMode(isDocumentDarkMode());
        }
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-bs-theme']
    });

    return () => observer.disconnect();
  }, []);

  return isDarkMode;
};
